import { useLanguage } from "@/i18n";
import "@/LocaleSwitcher.css";

export default function LocaleSwitcher() {
  const { language, setLanguage } = useLanguage();
  return <div className="locale-switcher" data-testid="language-switcher" aria-label="Language selector">
    <button className={language === "english" ? "active" : ""} onClick={() => setLanguage("english")} data-testid="language-english-button" aria-label="English">EN</button>
    <button className={language === "indonesia" ? "active" : ""} onClick={() => setLanguage("indonesia")} data-testid="language-indonesia-button" aria-label="Indonesia">ID</button>
  </div>;
}